"use client";
// import { useState, useEffect } from "react";
// import Image from "next/image";
// import { Avatar, Blockquote } from "flowbite-react";

// const Testimonials = () => {
//   return (
//     <div
//       className="black-tint py-8 md:py-16 lg:py-24 -z-20 before:-z-10 before:bg-opacity-80"
//       style={{ backgroundImage: 'url("/images/business-coworkers.jpg")' }}
//     >
//       <div className="max-w-screen-xl mx-5 lg:mx-auto">
//         <div className="mb-6 md:mb-10 lg:mb-16 text-center">
//           <h2 className="font-bold text-white my-3">Client Testimonials</h2>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 lg:gap-14 items-stretch justify-between ">
//           <div className="bg-white border border-gray-300 shadow-xl p-6 md:p-10 rounded-lg">
//             <figure>
//               <Blockquote>
//                 <svg
//                   className="mb-4 h-8 w-8 text-red-600"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   viewBox="0 0 18 14"
//                 >
//                   <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
//                 </svg>
//                 <p className="text-base md:text-lg font-medium italic">
//                   “Our crew changes have been handled in the area of Panama, Sao
//                   Paulo ,Lome Aruba with 100% success within the time frame and
//                   budget that we expected. We highly recommend this company to
//                   other technical marine departments…”
//                 </p>
//               </Blockquote>
//               {/* <figcaption className="flex items-center justify-center">
//                 <Avatar
//                   rounded
//                   className="w-16 h-16 rounded-full self-start mr-4"
//                   img="/images/user1.jpg"
//                   alt="profile picture"
//                 />
//                 <div className="text-left">
//                   <div className="font-bold font-serif text-xl">
//                     Thome Group
//                   </div>
//                   <p className="text-sm">Technical Superintendent</p>
//                 </div>
//               </figcaption> */}
//             </figure>
//           </div>
//           <div className="bg-white border border-gray-300 shadow-xl p-6 md:p-10 rounded-lg">
//             <figure>
//               <Blockquote>
//                 <svg
//                   className="mb-4 h-8 w-8 text-red-600"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   viewBox="0 0 18 14"
//                 >
//                   <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
//                 </svg>
//                 <p className="text-base md:text-lg font-medium italic">
//                   “We are very happy to work with FHM Travels Pvt.
//                   Ltd. travel . Invoices and SOA are raised on time and as per
//                   our requirement with high accuracy .”
//                 </p>
//               </Blockquote>
//               {/* <figcaption className="flex items-center1 justify-center">
//                 <Avatar
//                   rounded
//                   className="w-16 h-16 rounded-full self-start mr-4"
//                   img="/images/user2.jpg"
//                   alt="profile picture"
//                 />
//                 <div className="text-left">
//                   <div className="font-bold font-serif text-xl">Symphony</div>
//                   <p className="text-sm">Accountant</p>
//                 </div>
//               </figcaption> */}
//             </figure>
//           </div>
//           <div className="bg-white border border-gray-300 shadow-xl p-6 md:p-10 rounded-lg">
//             <figure>
//               <Blockquote>
//                 <svg
//                   className="mb-4 h-8 w-8 text-red-600"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   viewBox="0 0 18 14"
//                 >
//                   <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
//                 </svg>
//                 <p className="text-base md:text-lg font-medium italic">
//                   “You did a fabulous job. There were no hitches.  Everything
//                   was included, and exactly what was promised to us.  Thank you
//                   again for all your work planning this trip. We will definitely
//                   recommend you.”
//                 </p>
//               </Blockquote>
//               {/* <figcaption className="flex items-center justify-center">
//                 <Avatar
//                   rounded
//                   className="w-16 h-16 rounded-full self-start mr-4"
//                   img="/images/user3.jpg"
//                   alt="profile picture"
//                 />
//                 <div className="text-left">
//                   <div className="font-bold font-serif text-xl">Director</div>
//                   <p className="text-sm">
//                     (S & F financial  services after experiencing customized
//                     North East Trip )
//                   </p>
//                 </div>
//               </figcaption> */}
//             </figure>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Testimonials;
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import Image from "next/image";

const NextArrow = ({ onClick }) => {
  return (
    <button
      className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
      onClick={onClick}
    >
      <FiArrowRight size={24} />
    </button>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <button
      className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
      onClick={onClick}
    >
      <FiArrowLeft size={24} />
    </button>
  );
};

const TestimonialsSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => (
      <div>
        <ul className="slick-dots"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
    ),
  };

  return (
    <section className="py-16 bg-gray-100">
      <div className="max-w-screen-xl mx-auto text-center">
        <p className=" text-6xl text-black font-bold pb-10 ">
          Client Testimonials
        </p>
        <div className="relative">
          <Slider {...settings}>
            <div className="px-24 py-10 bg-white   relative  ">
              {/* Top Left Quote Image */}
              <div className="text-blue-200 text-6xl mb-6">
                <Image
                  src="/images/left-quote-svgrepo-com.svg"
                  alt="Left Quote Icon"
                  width={36}
                  height={36}
                />
              </div>

              {/* Quote Text */}
              <p className="text-black text-2xl font-semibold leading-9">
                "What a blast! Everyone had an amazing time—definitely the best
                launch we’ve ever had!"
              </p>

              {/* Bottom Right Quote Image */}
              <div className="absolute bottom-8 right-8 text-blue-200">
                <Image
                  src="/images/right-quote-svgrepo-com.svg"
                  alt="Right Quote Icon"
                  width={36}
                  height={36}
                />
              </div>
            </div>

            <div className="p-14 bg-white   relative  ">
              {/* Top Left Quote Image */}
              <div className="text-blue-200 text-6xl mb-6">
                <Image
                  src="/images/left-quote-svgrepo-com.svg"
                  alt="Left Quote Icon"
                  width={36}
                  height={36}
                />
              </div>

              {/* Quote Text */}
              <p className="text-black text-2xl font-semibold leading-9">
                "The most fun we've had at a corporate event!"
              </p>

              {/* Bottom Right Quote Image */}
              <div className="absolute bottom-8 right-8 text-blue-200">
                <Image
                  src="/images/right-quote-svgrepo-com.svg"
                  alt="Right Quote Icon"
                  width={36}
                  height={36}
                />
              </div>
            </div>

            <div className="p-14 bg-white  relative ">
              {/* Top Left Quote Image */}
              <div className="text-blue-200 text-6xl mb-6">
                <Image
                  src="/images/left-quote-svgrepo-com.svg"
                  alt="Left Quote Icon"
                  width={36}
                  height={36}
                />
              </div>

              {/* Quote Text */}
              <p className="text-black text-2xl font-semibold leading-9">
                "The press conference was exceptionally well-organized, the
                energy was electric, and the interactive discussions felt more
                than just a typical press conference!"
              </p>

              {/* Bottom Right Quote Image */}
              <div className="absolute bottom-8 right-8 text-blue-200">
                <Image
                  src="/images/right-quote-svgrepo-com.svg"
                  alt="Right Quote Icon"
                  width={36}
                  height={36}
                />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
